module.exports = __webpack_public_path__ + "static/img/wxSignIn.6ae4cd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/wxSignIn.jpg
// module id = C8j8
// module chunks = 55